/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ServerDefs from "./defs.defs.js";

const $nsid = "place.stream.server.getWebhook";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"id":/*#__PURE__*/ l.string()});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"webhook":/*#__PURE__*/ l.ref<ServerDefs.Webhook>((() => ServerDefs.webhook) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get details for a specific webhook. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["WebhookNotFound","Unauthorized"]);

export { main };

export const $lxm = $nsid;
